import {Params} from 'react-router'

// Common route segments shared between entrypoints (POM standalone and Suite).
// These do NOT include the plant identifier prefix — each entrypoint prepends its own.
export const DASHBOARD_SEGMENT = 'dashboard'
export const SECTION_SEGMENT = 'section/:sectionId'
export const SUB_SECTION_SEGMENT = 'subsection/:sectionId/:topicId'

// Full path patterns used by features/pom (upm plantId-based URLs).
// Feature components should use usePomNavigation() instead of these directly.
const PLANT_ROOT = '/:plantId'
export const DASHBOARD = `${PLANT_ROOT}/${DASHBOARD_SEGMENT}`
export const PLANT_SECTION = `${PLANT_ROOT}/${SECTION_SEGMENT}`
export const PLANT_SUB_SECTION = `${PLANT_ROOT}/${SUB_SECTION_SEGMENT}`
// TODO: this will be removed during integration with suite, used to redirect user on BE failure with 403
export const ERROR_403 = '/error403'

export interface PathParameters extends Params {
  plantId?: string
  sectionId?: string
  topicId?: string
}
